export default __webpack_public_path__ + "static/media/icon-folders.ebc43dc1.svg";